import { DiveSite } from '../types/DiveSite';

export const importedDiveSiteCatalog: DiveSite[] = [
  {
    id: 'hilma-hooker',
    slug: 'hilma-hooker',
    name: 'Hilma Hooker',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.105111,
    longitude: -68.288528,
    matchRadiusKm: 6,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A Bonaire wreck site resting on sand near Angel City, known for easy exterior exploration, strong photo appeal, and classic Caribbean wreck-diving conditions.',
    highlights: ['Full-profile wreck dive', 'Angel City area', 'Strong Caribbean wreck reputation'],
    tags: ['caribbean', 'bonaire', 'wreck', 'shore-access region', 'photography'],
    aliases: ['hilma', 'hilma hooker wreck', 'angel city wreck'],
  },
  {
    id: 'usns-vandenberg',
    slug: 'usns-vandenberg',
    name: 'USNS Vandenberg',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.45,
    longitude: -81.733333,
    matchRadiusKm: 10,
    siteType: 'wreck',
    difficulty: 'Advanced',
    featured: true,
    summary: 'A massive artificial reef off Key West that draws wreck divers for its scale, depth, and large superstructure across multiple recreational and technical profiles.',
    highlights: ['Large artificial reef', 'Key West flagship wreck', 'Multi-level exploration'],
    tags: ['florida', 'keys', 'wreck', 'artificial reef', 'advanced'],
    aliases: ['vandenberg', 'general hoyt s vandenberg', 'uss vandenberg'],
  },
  {
    id: 'deans-blue-hole',
    slug: 'deans-blue-hole',
    name: "Dean's Blue Hole",
    region: 'Long Island, Bahamas',
    country: 'Bahamas',
    latitude: 23.106389,
    longitude: -75.008611,
    matchRadiusKm: 5,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    featured: true,
    summary: 'A world-famous Bahamian blue hole near Clarence Town, best known for its extreme depth and its role as a landmark freediving venue.',
    highlights: ['Iconic freediving site', 'Very deep blue hole', 'Clarence Town landmark'],
    tags: ['bahamas', 'blue hole', 'freediving', 'advanced', 'caribbean'],
    aliases: ['deans hole', 'dean blue hole', 'clarence town blue hole'],
  },
  {
    id: 'blue-corner-palau',
    slug: 'blue-corner-palau',
    name: 'Blue Corner',
    region: 'Koror, Palau',
    country: 'Palau',
    latitude: 7.133611,
    longitude: 134.220278,
    matchRadiusKm: 8,
    siteType: 'drift',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A signature Palau reef corner where current-driven diving, reef hooks, and dense fish life make it one of the region’s most recognizable sites.',
    highlights: ['Current-based corner diving', 'High fish density', 'Classic Palau reef scene'],
    tags: ['palau', 'drift', 'reef', 'current', 'pelagics'],
    aliases: ['blue corner palau', 'palau blue corner'],
  },
  {
    id: 'peacock-springs',
    slug: 'peacock-springs',
    name: 'Peacock Springs',
    region: 'Live Oak, Florida',
    country: 'United States',
    latitude: 30.166667,
    longitude: -83.016667,
    matchRadiusKm: 8,
    siteType: 'spring',
    difficulty: 'Advanced',
    featured: true,
    summary: 'A flagship North Florida cave system known for long submerged passages, multiple entrances, and its importance in cave-diver training and exploration.',
    highlights: ['Major cave-country system', 'Multiple cave entrances', 'Technical cave-diving reputation'],
    tags: ['florida', 'cave', 'spring', 'technical', 'cave-country'],
    aliases: ['peacock', 'peacock springs state park', 'wes skiles peacock springs'],
  },
  {
    id: 'devils-eye',
    slug: 'devils-eye',
    name: "Devil's Eye",
    region: 'Williston, Florida',
    country: 'United States',
    latitude: 29.834722,
    longitude: -82.698611,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Advanced',
    featured: true,
    summary: 'A famous Ginnie Springs cave entrance recognized for clear water, strong flow, and direct access to one of Florida cave country’s best-known systems.',
    highlights: ['Iconic cave entrance', 'Very clear water', 'High-recognition Ginnie site'],
    tags: ['florida', 'cave', 'spring', 'technical', 'ginnie springs'],
    aliases: ['devils eye spring', 'devils eye ginnie', 'devils eye cave'],
  },
  {
    id: 'devils-ear',
    slug: 'devils-ear',
    name: "Devil's Ear",
    region: 'Williston, Florida',
    country: 'United States',
    latitude: 29.834167,
    longitude: -82.699167,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Advanced',
    featured: true,
    summary: 'A neighboring Ginnie Springs cave entrance known for stronger flow, overhead conditions, and its frequent pairing with Devil’s Eye in cave-diving itineraries.',
    highlights: ['Same system as Devil’s Eye', 'Stronger flow profile', 'Common cave-diver target'],
    tags: ['florida', 'cave', 'spring', 'technical', 'ginnie springs'],
    aliases: ['devils ear spring', 'devils ear ginnie', 'devils ear cave'],
  },
  {
    id: 'little-river-spring',
    slug: 'little-river-spring',
    name: 'Little River Spring',
    region: "O'Brien, Florida",
    country: 'United States',
    latitude: 30.0325,
    longitude: -82.949722,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Advanced',
    featured: true,
    summary: 'A classic Suwannee-area cave site with a deep spring basin, river setting, and a well-known cave entrance used by trained cave divers.',
    highlights: ['Deep spring basin', 'Suwannee River access area', 'Classic cave-country stop'],
    tags: ['florida', 'cave', 'spring', 'technical', 'suwannee'],
    aliases: ['little river', 'little river cave', 'little river spring cave'],
  },
  {
    id: 'orange-grove-sink',
    slug: 'orange-grove-sink',
    name: 'Orange Grove Sink',
    region: 'Branford, Florida',
    country: 'United States',
    latitude: 29.933333,
    longitude: -82.983333,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A well-known North Florida sink entrance into the Peacock system, recognized by cave divers as one of the area’s classic technical access points.',
    highlights: ['Peacock system entrance', 'North Florida sink site', 'Established cave-diving landmark'],
    tags: ['florida', 'cave', 'sink', 'technical', 'peacock system'],
    aliases: ['orange grove', 'orange grove cave', 'orange grove sink cave'],
  },
  {
    id: 'royal-springs',
    slug: 'royal-springs',
    name: 'Royal Springs',
    region: "O'Brien, Florida",
    country: 'United States',
    latitude: 30.059444,
    longitude: -82.958056,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A Suwannee River spring with cavern and cave access, known for its dramatic basin and popularity among trained cave divers and photographers.',
    highlights: ['Large spring basin', 'Cavern-to-cave profile', 'Popular training and photo site'],
    tags: ['florida', 'cave', 'spring', 'cavern', 'suwannee'],
    aliases: ['royal spring', 'royal springs cave'],
  },
  {
    id: 'jackson-blue-spring',
    slug: 'jackson-blue-spring',
    name: 'Jackson Blue Spring',
    region: 'Marianna, Florida',
    country: 'United States',
    latitude: 30.779722,
    longitude: -85.173333,
    matchRadiusKm: 6,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A major Panhandle spring system valued for strong visibility, cavern access, and an extensive underwater cave network tied to the Merritt’s Mill Pond area.',
    highlights: ['Panhandle cave system', 'Strong visibility', 'Merritt’s Mill Pond access'],
    tags: ['florida', 'cave', 'spring', 'technical', 'panhandle'],
    aliases: ['jackson blue', 'jackson blue cave', 'jackson blue spring cave'],
  },
  {
    id: 'eagles-nest-sink',
    slug: 'eagles-nest-sink',
    name: "Eagle's Nest",
    region: 'Weeki Wachee, Florida',
    country: 'United States',
    latitude: 28.513333,
    longitude: -82.558611,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Advanced',
    featured: true,
    summary: 'An iconic but hazardous deep sinkhole system in west-central Florida, widely regarded as one of the state’s most demanding cave-diving sites.',
    highlights: ['Deep vertical sink profile', 'Serious technical reputation', 'Iconic advanced cave site'],
    tags: ['florida', 'cave', 'spring', 'technical', 'deep'],
    aliases: ['eagles nest sink', 'eagles nest cave', 'eagles nest'],
  },
  {
    id: 'salt-pier',
    slug: 'salt-pier',
    name: 'Salt Pier',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.085833,
    longitude: -68.281389,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Beginner',
    featured: true,
    summary: 'One of Bonaire’s signature shore dives, known for easy access, pier pilings coated in marine life, and strong wide-angle and macro photo appeal.',
    highlights: ['Famous shore dive', 'Colorful pier structure', 'Photo-friendly marine life'],
    tags: ['caribbean', 'bonaire', 'reef', 'shore dive', 'photography'],
    aliases: ['bonaire salt pier', 'salt pier bonaire'],
  },
  {
    id: 'tugboat-curacao',
    slug: 'tugboat-curacao',
    name: 'Tugboat',
    region: 'Curacao',
    country: 'Curacao',
    latitude: 12.070833,
    longitude: -68.878611,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A shallow Curacao favorite centered on a small wreck coated in growth, making it one of the island’s best-known easy wreck and photography dives.',
    highlights: ['Shallow wreck', 'Easy access profile', 'Popular photo subject'],
    tags: ['caribbean', 'curacao', 'wreck', 'shore dive', 'photography'],
    aliases: ['curacao tugboat', 'tugboat wreck curacao'],
  },
  {
    id: 'uss-kittiwake',
    slug: 'uss-kittiwake',
    name: 'USS Kittiwake',
    region: 'Grand Cayman',
    country: 'Cayman Islands',
    latitude: 19.366389,
    longitude: -81.408333,
    matchRadiusKm: 6,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A purpose-sunk Grand Cayman wreck that offers a clean structure, easy orientation, and one of the island’s most recognizable artificial reef dives.',
    highlights: ['Purpose-sunk wreck', 'Grand Cayman signature site', 'Good wreck orientation'],
    tags: ['caribbean', 'cayman islands', 'wreck', 'artificial reef', 'grand cayman'],
    aliases: ['kittiwake', 'kittiwake wreck', 'uss kittiwake grand cayman'],
  },
  {
    id: 'marys-place-roatan',
    slug: 'marys-place-roatan',
    name: "Mary's Place",
    region: 'Roatan',
    country: 'Honduras',
    latitude: 16.244722,
    longitude: -86.348333,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A celebrated Roatan reef site best known for its narrow coral canyon, dramatic swim-through feel, and classic Bay Islands visibility.',
    highlights: ['Coral canyon profile', 'Signature Roatan site', 'Strong reef scenery'],
    tags: ['caribbean', 'roatan', 'reef', 'swim-through', 'bay islands'],
    aliases: ['marys place', 'marys place roatan'],
  },
  {
    id: 'thousand-steps-bonaire',
    slug: 'thousand-steps-bonaire',
    name: '1000 Steps',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.245833,
    longitude: -68.369722,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A famous Bonaire shore dive known for its limestone stair access, clear reef slope, and frequent pairing with nearby northern shore sites.',
    highlights: ['Classic Bonaire shore dive', 'Limestone stair access', 'Clear sloping reef'],
    tags: ['caribbean', 'bonaire', 'reef', 'shore dive', 'beginner'],
    aliases: ['1000 steps bonaire', 'thousand steps', 'duizend trappen'],
  },
  {
    id: 'alice-in-wonderland-bonaire',
    slug: 'alice-in-wonderland-bonaire',
    name: 'Alice in Wonderland',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.151667,
    longitude: -68.2875,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A popular Bonaire reef site recognized for easy access, healthy coral structure, and the relaxed shore-diving profile that defines the island.',
    highlights: ['Popular shore access', 'Healthy coral profile', 'Beginner-friendly Bonaire diving'],
    tags: ['caribbean', 'bonaire', 'reef', 'shore dive', 'photography'],
    aliases: ['alice in wonderland bonaire', 'alice wonderland bonaire'],
  },
  {
    id: 'superior-producer',
    slug: 'superior-producer',
    name: 'Superior Producer',
    region: 'Curacao',
    country: 'Curacao',
    latitude: 12.090833,
    longitude: -68.9325,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Advanced',
    featured: true,
    summary: 'One of the Caribbean’s best-known deep wreck dives, this Curaçao freighter draws advanced divers for its scale, depth, and marine growth.',
    highlights: ['Iconic Caribbean wreck', 'Deeper advanced profile', 'Strong photo appeal'],
    tags: ['caribbean', 'curacao', 'wreck', 'advanced', 'photography'],
    aliases: ['superior producer curacao', 'curacao superior producer', 'superior producer wreck'],
  },
  {
    id: 'palancar-reef',
    slug: 'palancar-reef',
    name: 'Palancar Reef',
    region: 'Cozumel',
    country: 'Mexico',
    latitude: 20.338611,
    longitude: -87.028611,
    matchRadiusKm: 8,
    siteType: 'drift',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A flagship Cozumel drift-diving area known for coral formations, swim-through structure, and the long reef sections that define the island’s marine park.',
    highlights: ['Signature Cozumel drift site', 'Coral buttresses and swim-throughs', 'Marine park classic'],
    tags: ['caribbean', 'cozumel', 'drift', 'reef', 'wall'],
    aliases: ['palancar', 'palancar gardens', 'palancar horseshoe', 'palancar caves'],
  },
  {
    id: 'santa-rosa-wall',
    slug: 'santa-rosa-wall',
    name: 'Santa Rosa Wall',
    region: 'Cozumel',
    country: 'Mexico',
    latitude: 20.345278,
    longitude: -87.024444,
    matchRadiusKm: 8,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A benchmark Cozumel wall dive where current, visibility, and reef drop-offs combine into one of the island’s most recognizable boat dives.',
    highlights: ['Classic wall profile', 'Current-driven Cozumel diving', 'Recognizable marine park site'],
    tags: ['caribbean', 'cozumel', 'drift', 'wall', 'reef'],
    aliases: ['santa rosa', 'cozumel santa rosa wall', 'santa rosa reef'],
  },
  {
    id: 'catfish-hotel',
    slug: 'catfish-hotel',
    name: 'Catfish Hotel',
    region: 'High Springs, Florida',
    country: 'United States',
    latitude: 29.833889,
    longitude: -82.697778,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A well-known feature within the Ginnie Springs system that cave divers frequently reference as a distinct target inside one of Florida’s busiest cave areas.',
    highlights: ['Recognizable Ginnie waypoint', 'Technical cave reference point', 'Part of major spring system'],
    tags: ['florida', 'cave', 'spring', 'technical', 'ginnie springs'],
    aliases: ['catfish hotel ginnie', 'ginnie catfish hotel'],
  },
  {
    id: 'buford-spring',
    slug: 'buford-spring',
    name: 'Buford Spring',
    region: 'Branford, Florida',
    country: 'United States',
    latitude: 29.931111,
    longitude: -82.989444,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A North Florida spring site tied to cave-country diving, known among trained divers as another technical freshwater option near Branford.',
    highlights: ['Branford cave-country site', 'Technical freshwater access', 'Additional Suwannee-area spring'],
    tags: ['florida', 'cave', 'spring', 'technical', 'branford'],
    aliases: ['buford spring cave', 'buford sink'],
  },
  {
    id: 'merritts-mill-pond',
    slug: 'merritts-mill-pond',
    name: "Merritt's Mill Pond",
    region: 'Marianna, Florida',
    country: 'United States',
    latitude: 30.773333,
    longitude: -85.174444,
    matchRadiusKm: 7,
    siteType: 'lake',
    difficulty: 'Intermediate',
    summary: 'A clear freshwater Panhandle basin associated with several cave and spring accesses, making it a common reference point for Marianna-area diving.',
    highlights: ['Marianna freshwater landmark', 'Links multiple spring accesses', 'Clear Panhandle water'],
    tags: ['florida', 'freshwater', 'panhandle', 'spring', 'training'],
    aliases: ['merritts mill', 'merritts mill pond florida', 'merritts pond'],
  },
  {
    id: 'gilchrist-blue-springs',
    slug: 'gilchrist-blue-springs',
    name: 'Gilchrist Blue Springs',
    region: 'High Springs, Florida',
    country: 'United States',
    latitude: 29.826111,
    longitude: -82.760833,
    matchRadiusKm: 6,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A clear public spring near High Springs that broadens the catalog’s north Florida freshwater coverage beyond the more cave-focused headline sites.',
    highlights: ['Public freshwater spring', 'Strong visibility', 'Easy recreational profile'],
    tags: ['florida', 'spring', 'freshwater', 'beginner', 'north florida'],
    aliases: ['gilchrist blue', 'gilchrist blue spring', 'gilchrist springs'],
  },
  {
    id: 'port-royal-jamaica',
    slug: 'port-royal-jamaica',
    name: 'Port Royal',
    region: 'Kingston, Jamaica',
    country: 'Jamaica',
    latitude: 17.9375,
    longitude: -76.841944,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A historic Jamaica site associated with the submerged remains of the old pirate-era city, drawing divers interested in archaeology, history, and unusual Caribbean wreck-style exploration.',
    highlights: ['Flooded historic city remains', 'Strong pirate-history appeal', 'Archaeology-focused dive interest'],
    tags: ['caribbean', 'jamaica', 'historic', 'wreck', 'archaeology'],
    aliases: ['port royal', 'sunken port royal', 'flooded pirate town jamaica'],
  },
  {
    id: 'godzillas-lair-antigua',
    slug: 'godzillas-lair-antigua',
    name: "Godzilla's Lair",
    region: 'Antigua',
    country: 'Antigua and Barbuda',
    latitude: 17.173889,
    longitude: -61.891944,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A named Antigua reef site known for dramatic volcanic-style rock formations, swim-through character, and the sort of topography that makes it memorable on local boat-diving itineraries.',
    highlights: ['Distinctive rock formations', 'Memorable local Antigua site', 'Swim-through style terrain'],
    tags: ['caribbean', 'antigua', 'reef', 'boat dive', 'topography'],
    aliases: ['godzillas lair', 'godzilla lair antigua', 'godzillas lair antigua'],
  },
  {
    id: 'the-seas-epcot-divequest',
    slug: 'the-seas-epcot-divequest',
    name: 'The Seas DiveQuest',
    region: 'Walt Disney World, Florida',
    country: 'United States',
    latitude: 28.374694,
    longitude: -81.549389,
    matchRadiusKm: 3,
    siteType: 'destination',
    difficulty: 'Beginner',
    featured: true,
    summary: 'A guided aquarium dive experience inside EPCOT’s Seas pavilion, best known for easy controlled conditions and close viewing of marine life in a theme-park setting.',
    highlights: ['EPCOT aquarium dive', 'Controlled indoor conditions', 'Close marine life viewing'],
    tags: ['florida', 'aquarium', 'orlando', 'beginner', 'experience dive'],
    aliases: ['epcot aquarium dive', 'disney aquarium dive', 'divequest', 'the seas at epcot'],
  },
  {
    id: 'georgia-aquarium-atlanta',
    slug: 'georgia-aquarium-atlanta',
    name: 'Georgia Aquarium',
    region: 'Atlanta, Georgia',
    country: 'United States',
    latitude: 33.763361,
    longitude: -84.394056,
    matchRadiusKm: 3,
    siteType: 'destination',
    difficulty: 'Beginner',
    featured: true,
    summary: 'A large public-aquarium dive experience in Atlanta that stands out for controlled conditions, giant-tank scale, and the novelty of aquarium diving away from the coast.',
    highlights: ['Major public aquarium dive', 'Large exhibit tank experience', 'Controlled non-ocean diving'],
    tags: ['aquarium', 'atlanta', 'georgia', 'beginner', 'experience dive'],
    aliases: ['atlanta aquarium', 'georgia aquarium dive', 'journey with gentle giants'],
  },
  {
    id: 'devils-grotto-grand-cayman',
    slug: 'devils-grotto-grand-cayman',
    name: "Devil's Grotto",
    region: 'Grand Cayman',
    country: 'Cayman Islands',
    latitude: 19.3575,
    longitude: -81.393056,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A classic Grand Cayman dive known for coral canyons, tarpon sightings, and swim-through structure close to the island’s main west-side dive traffic.',
    highlights: ['Famous Cayman swim-throughs', 'Frequent tarpon interest', 'West-side boat-diving staple'],
    tags: ['caribbean', 'cayman islands', 'reef', 'swim-through', 'grand cayman'],
    aliases: ['devils grotto', 'devils grotto cayman', 'grand cayman devils grotto'],
  },
  {
    id: 'babylon-grand-cayman',
    slug: 'babylon-grand-cayman',
    name: 'Babylon',
    region: 'Grand Cayman',
    country: 'Cayman Islands',
    latitude: 19.376944,
    longitude: -81.182222,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A celebrated East End Cayman site recognized for dramatic coral pinnacles, stronger exposure, and some of the island’s most photogenic topography.',
    highlights: ['Iconic East End pinnacle scene', 'Photogenic coral structure', 'More exposed Cayman profile'],
    tags: ['caribbean', 'cayman islands', 'reef', 'pinnacle', 'grand cayman'],
    aliases: ['babylon cayman', 'babylon grand cayman'],
  },
  {
    id: 'el-aguila-cozumel',
    slug: 'el-aguila-cozumel',
    name: 'El Aguila',
    region: 'Cozumel',
    country: 'Mexico',
    latitude: 20.390278,
    longitude: -87.031389,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A well-known Cozumel wreck dive that complements the island’s reef drifts with a recognizable ship profile and frequent marine growth.',
    highlights: ['Popular Cozumel wreck', 'Distinct hull structure', 'Common reef-and-wreck combo dive'],
    tags: ['caribbean', 'cozumel', 'wreck', 'boat dive', 'intermediate'],
    aliases: ['wreck of el aguila', 'cozumel el aguila', 'aguila wreck'],
  },
  {
    id: 'hole-in-the-wall-roatan',
    slug: 'hole-in-the-wall-roatan',
    name: 'Hole in the Wall',
    region: 'Roatan',
    country: 'Honduras',
    latitude: 16.406944,
    longitude: -86.6275,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A named Roatan reef site known for a dramatic break in the wall, blue-water exposure, and the stronger topography found on the island’s far side.',
    highlights: ['Distinct wall opening', 'Blue-water feel', 'Recognizable Roatan topography'],
    tags: ['caribbean', 'roatan', 'reef', 'wall', 'bay islands'],
    aliases: ['hole in the wall roatan', 'roatan hole in the wall'],
  },
  {
    id: 'wreck-of-the-rhone',
    slug: 'wreck-of-the-rhone',
    name: 'Wreck of the Rhone',
    region: 'British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.381111,
    longitude: -64.439444,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A landmark Caribbean wreck in the British Virgin Islands that blends maritime history, recognizable structure, and strong appeal for recreational wreck divers.',
    highlights: ['Historic Caribbean wreck', 'Very recognizable site name', 'Popular BVI signature dive'],
    tags: ['caribbean', 'british virgin islands', 'wreck', 'historic', 'photography'],
    aliases: ['rhone', 'rms rhone', 'wreck of rhone', 'rhone bvi'],
  },
];